<div style="position: relative; width: 100%; margin: auto">
  <div *ngIf="isLoading" class="loading-chart">
    <ion-spinner></ion-spinner>
    <div>Loading chart data...</div>
  </div>

  <!-- Show cards when chart style is cards -->
  <div
    *ngIf="
      !isLoading &&
      !chartConfig.error &&
      chartConfig.chartType === 'cards' &&
      !showTable
    "
    class="cards-container"
  >
    <div class="cards-grid">
      <ion-card *ngFor="let item of totalValues" class="card">
        <div class="card-content">
          <div class="report-title">
            <ion-icon
              *ngIf="item.dimensionData?.icon"
              [name]="item.dimensionData.icon"
              [class]="item.dimensionData.iconClass"
              class="card-icon"
            ></ion-icon>
            {{ item.label }}
          </div>
          <div class="report-stat">{{ item.value | number }}</div>
        </div>
      </ion-card>
    </div>
  </div>

  <!-- Show chart when not in table view and not showing cards -->
  <div
    style="height: 372px"
    *ngIf="!showTable && chartConfig.chartType !== 'cards'"
  >
    <canvas
      *ngIf="
        !isLoading &&
        !chartConfig.error &&
        !showTable &&
        chartConfig.chartType !== 'cards'
      "
      baseChart
      [type]="chartConfig.chartType"
      [datasets]="chartConfig.chartData.datasets"
      [labels]="chartConfig.chartData.labels"
      [options]="chartConfig.chartOptions"
    >
    </canvas>
  </div>

  <!-- Show table when in table view and not showing cards -->
  <div *ngIf="!isLoading && !chartConfig.error && showTable" class="table-view">
    <ngx-datatable
      class="material"
      [limit]="100"
      [headerHeight]="50"
      [footerHeight]="50"
      [rowHeight]="50"
      [scrollbarH]="true"
      [rows]="tabularData"
      [reorderable]="true"
    >
      <ngx-datatable-column
        name="Dimension"
        prop="dimensionLabel"
        [sortable]="false"
        [frozenLeft]="true"
        [width]="250"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-icon
            *ngIf="row.dimensionData?.icon"
            [name]="row.dimensionData.icon"
            [class]="row.dimensionData.iconClass"
            style="margin-right: 5px"
          ></ion-icon>
          {{ row.dimensionLabel }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngFor="let label of chartConfig.chartData.labels"
        [name]="label"
        [prop]="label"
        [sortable]="true"
        [width]="115"
      >
        <ng-template let-value="value" ngx-datatable-cell-template>
          {{ value | number }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Total"
        prop="total"
        [sortable]="true"
        [width]="115"
        *ngIf="showTotalColumn"
      >
        <ng-template let-value="value" ngx-datatable-cell-template>
          {{ value | number }}
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>

  <div *ngIf="chartConfig.error" class="chart-error">
    {{ chartConfig.error }}
  </div>

  <div *ngIf="!savedReportId" class="no-chart-data">
    No chart data available
  </div>
</div>
